import { render, staticRenderFns } from "./MintNftWizardVertical.vue?vue&type=template&id=0430a06c&"
import script from "./MintNftWizardVertical.vue?vue&type=script&lang=js&"
export * from "./MintNftWizardVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports